export default __webpack_public_path__ + "static/media/app-store.b08d70eb.png";